import { Injectable, signal } from "@angular/core";
import { WarehouseConfiguration } from "src/app/backend/models/configuration/warehouse-configuration";
import { HealthcareConfiguration } from "src/app/backend/models/healthcare-configuration";

@Injectable()
export class ConfigurationService {
  warehouse = signal<WarehouseConfiguration>({
    id: "",
    enabled: false,
    forceUnloading: false,
    disableProductUnloading: false,
    version: 0
  });

  healthcare = signal<HealthcareConfiguration>({
    account: "",
    id: "",
    lis: {},
    tenant: ""
  });
}
